export default {
  login: {
    welcome: 'おかえりなさい',
    subtitle: 'ログインして買い物を続ける',
    phonePlaceholder: '電話番号を入力してください',
    passwordPlaceholder: 'パスワードを入力してください',
    showPassword: '表示',
    hidePassword: '非表示',
    loginButton: 'ログイン',
    registerButton: '無料登録',
    title: 'ログイン',
    subtitle2: '報酬を得るためのワンストップグローバルショッピング',
    logging: 'ログイン中...',
    phoneRequired: '電話番号を入力してください',
    passwordRequired: 'パスワードを入力してください',
    loginSuccess: 'ログイン成功',
    loginFailed: 'ログイン失敗',
    loginError: 'ログインエラー、後でもう一度お試しください'
  },
  register: {
    title: 'アカウント作成',
    subtitle: '私たちに参加して、取引の旅を始めましょう',
    username: 'ユーザー名',
    phone: '電話番号',
    loginPassword: 'ログインパスワード',
    transactionPassword: '取引パスワード',
    invitationCode: '招待コード',
    usernamePlaceholder: 'ユーザー名を入力してください',
    phonePlaceholder: '電話番号を入力してください',
    loginPasswordPlaceholder: 'ログインパスワードを入力してください',
    transactionPasswordPlaceholder: '取引パスワードを入力してください',
    invitationCodePlaceholder: '招待コードを入力してください',
    registerButton: '登録',
    hasAccount: 'すでにアカウントをお持ちですか？ ログイン',
    errorUsername: 'ユーザー名を入力してください',
    errorPhone: '電話番号を入力してください',
    errorLoginPassword: 'ログインパスワードを入力してください',
    errorTransactionPassword: '取引パスワードを入力してください',
    errorInviteCode: '招待コードを入力してください',
    registerSuccess: '登録成功'
  },
  tabbar: {
    home: 'ホーム',
    purchase: '注文履歴',
    grabbing: '注文',
    kefu: 'カスタマーサービス',
    my: 'マイ'
  },
  home: {
    orderCount: '注文数',
    upgradeAmount: '入金してアップグレード',
    recharge: '入金',
    withdraw: '出金',
    team: 'チーム管理',
    commission: 'コミッションを取得',
    newProducts: '新商品',
    newProductsDesc: '新シーズンおよび未来のコレクションの最新スタイル。',
    buyNow: '今すぐ購入',
    nowAvailable: '今すぐ利用可能',
    nowAvailableDesc: 'ウェディングシーズンに備え、次の旅行のために荷物をまとめ、コミットメントなしでワードローブを更新しましょう。新しいレンタルプランで、最新のトレンドを試し、サブスクリプションなしで予算内に収めることができます。',
    footerTitle: 'Desigual.com',
    footerFollow: "{'@'}Desigual.comでフォローして、お気に入りのDesigual.comスタイルを共有しましょう！",
    footerShop: 'カタログを閲覧'
  },
  purchase: {
    all: 'すべて',
    pending: '保留中',
    completed: '完了',
    frozen: '凍結中',
    balance: 'アカウント残高',
    orderTime: '注文時刻',
    orderId: '注文番号',
    totalAmount: '注文総額',
    commission: 'コミッション',
    expectedReturn: '期待される返金',
    submitOrder: '注文を送信',
    orderCompleted: '注文完了',
    loading: '読み込み中...',
    noData: '注文データがありません',
    noMore: 'これ以上ありません',
    orderSuccess: '注文成功',
    orderNumber: '注文番号',
    rating: '評価',
    notSubmit: 'まだ送信しない',
    submitNow: '今すぐ送信',
    submitting: '送信中...',
    submitFailed: '送信失敗',
    grabOrderFailed: '注文取得失敗、後でもう一度お試しください',
    getOrderInfoFailed: '注文詳細の取得に失敗しました',
    submitOrderFailed: '送信失敗、後でもう一度お試しください'
  },
  common: {
    home: 'ホーム',
    about: 'について',
    contact: 'お問い合わせ',
    purchase: '注文履歴',
    grabbing: '注文',
    my: 'マイ',
    login: 'ログイン',
    register: '登録',
    kefu: 'カスタマーサービス',
    loadDataError: 'データの読み込みに失敗しました、後でもう一度お試しください',
    success: '操作成功',
    failed: '操作失敗',
    submitSuccess: '送信成功',
    submitFailed: '送信失敗',
    submitting: '送信中...'
  },
  grabbing: {
    accountAmount: 'アカウント金額',
    accountBalance: 'アカウント残高',
    getCommission: 'コミッションを取得',
    ordersGrabbedToday: '本日取得した注文',
    orderCount: '注文数',
    operationSteps: '操作手順',
    step1: '1. タスク開始ボタンをクリックし、指示に従ってタスクを完了してください',
    step2: '2. タスク完了後、コミッションを残高に決済できます',
    grabOrder: '注文を取得',
    pleaseWait: 'お待ちください',
    grabSuccess: '注文成功',
    grabTime: '注文時刻',
    grabNumber: '注文番号',
    orderTotal: '注文総額',
    commission: 'コミッション',
    expectedReturn: '期待される返金',
    rating: '評価',
    notSubmit: 'まだ送信しない',
    submitNow: '今すぐ送信',
    submitting: '送信中...'
  },
  kefu: {
    title: 'カスタマーサービス',
    intro: {
      line1: 'ご質問やご不明な点がございましたら、',
      line2: 'カスタマーサービスにお問い合わせください'
    },
    serviceTime: {
      label: '営業時間',
      text: '専用カスタマーサービス',
      online: 'オンライン'
    },
    contact: {
      title: '連絡先',
      name: 'オンライン',
      status: '相談',
      feature1: '即時返信',
      feature2: 'プロフェッショナルサービス',
      button: '連絡する'
    },
    faq: {
      title: 'よくある質問',
      rechargeQuestion: '入金方法は？',
      rechargeAnswer: '安全な決済ゲートウェイを通じて入金できます。マイアカウント > 入金に移動し、指示に従ってください。',
      withdrawQuestion: '出金方法は？',
      withdrawAnswer: '出金はマイアカウント > 出金から行えます。アカウントが認証されていることを確認してください。',
      minRechargeQuestion: '最低入金額は？',
      minRechargeAnswer: '最低入金額は${currency}68です。',
      withdrawTimeQuestion: '出金にはどのくらいかかりますか？',
      withdrawTimeAnswer: '出金は通常24時間以内に処理されます。',
      securityQuestion: '私の情報は安全ですか？',
      securityAnswer: 'はい、業界標準の暗号化技術を使用して、個人情報と財務情報を保護しています。'
    }
  },
  my: {
    inviteCode: '招待コード',
    copy: 'コピー',
    copySuccess: 'コピー成功',
    copyFailed: 'コピー失敗',
    online: 'オンライン',
    accountAmount: 'アカウント金額',
    balance: 'アカウント残高',
    accountBalanceTrend: 'アカウント残高',
    todayCommission: '本日のコミッション',
    totalCommission: '総コミッション',
    today: '今日',
    total: '合計',
    todayOrders: '本日取得した注文',
    orderCount: '注文数',
    recharge: '入金',
    withdraw: '出金',
    rechargeRecord: '入金履歴',
    withdrawRecord: '出金履歴',
    accountDetails: 'アカウント詳細',
    receivingAccount: '受取アカウント',
    bankAccount: '銀行口座',
    bankAccountDesc: '銀行口座',
    usdt: 'USDT',
    usdtDesc: 'USDTアドレス',
    connect: '接続',
    teamManagement: 'チーム管理',
    viewTeam: 'チームを表示',
    changePassword: 'パスワード変更',
    changeWithdrawPassword: '出金パスワード変更',
    passwordSettings: 'パスワード設定',
    logout: 'ログアウト',
    signOut: 'ログアウト',
    version: 'バージョン'
  },
  changePasswordPage: {
    currentPassword: '現在のログインパスワード',
    currentPasswordPlaceholder: '現在のパスワードを入力してください',
    newPassword: '新しいログインパスワード',
    newPasswordPlaceholder: '新しいパスワードを入力してください',
    confirmPassword: 'ログインパスワードを確認',
    confirmPasswordPlaceholder: '新しいパスワードを確認してください',
    notice: 'ログインパスワードはアカウントへのアクセスに使用されます。パスワードは6文字以上で、文字と数字を含む必要があります。',
    updateButton: 'ログインパスワードを更新',
    errorOldPassword: '現在のパスワードを入力してください',
    errorNewPassword: '新しいパスワードを入力してください',
    errorConfirmPassword: '新しいパスワードを確認してください',
    errorPasswordMismatch: 'パスワードが一致しません',
    errorPasswordLength: 'パスワードは6文字以上である必要があります',
    errorPasswordFormat: 'パスワードには文字と数字を含める必要があります'
  },
  changeWithdrawPasswordPage: {
    currentPassword: '現在の出金パスワード',
    currentPasswordPlaceholder: '現在の出金パスワードを入力してください',
    newPassword: '新しい出金パスワード',
    newPasswordPlaceholder: '新しい出金パスワードを入力してください',
    confirmPassword: '出金パスワードを確認',
    confirmPasswordPlaceholder: '新しい出金パスワードを確認してください',
    notice: '出金パスワードは資金の出金操作に使用されます。パスワードは6文字以上で、文字と数字を含む必要があります。',
    updateButton: '出金パスワードを更新',
    errorOldPassword: '現在の出金パスワードを入力してください',
    errorNewPassword: '新しい出金パスワードを入力してください',
    errorConfirmPassword: '新しい出金パスワードを確認してください',
    errorPasswordMismatch: 'パスワードが一致しません',
    errorPasswordLength: 'パスワードは6文字以上である必要があります',
    errorPasswordFormat: 'パスワードには文字と数字を含める必要があります'
  },
  details: {
    loading: '読み込み中...',
    noRecords: 'レコードがありません',
    noMore: 'これ以上ありません',
    time: '時刻',
    type: 'タイプ',
    amount: '金額',
    balance: '残高',
    remark: '備考',
    type0: 'その他',
    type1: '入金',
    type2: '出金',
    type3: '取引',
    type4: '注文コミッション',
    type5: '下位コミッション',
    type8: '出金拒否'
  },
  rechargeRecord: {
    offline: 'オフライン入金',
    online: 'オンライン入金',
    loading: '読み込み中...',
    noRecords: 'レコードがありません',
    orderNo: '注文番号',
    rechargeAmount: '入金額',
    rechargeTime: '入金時刻',
    payMethod: '支払い方法',
    rechargeStatus: '入金ステータス',
    noMore: 'これ以上ありません',
    statusPending: '承認待ち',
    statusApproved: '承認済み',
    statusFailed: '失敗',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: '読み込み中...',
    noRecords: 'レコードがありません',
    orderNo: '注文番号',
    withdrawAmount: '出金額',
    withdrawTime: '出金時刻',
    withdrawAddress: '出金アドレス',
    withdrawStatus: '出金ステータス',
    noMore: 'これ以上ありません',
    statusPending: '処理中',
    statusApproved: '成功',
    statusFailed: '失敗',
    statusEmpty: ''
  },
  withdraw: {
    title: '出金',
    method: '出金方法',
    methodSubtitle: '出金方法を選択してください',
    bankInfo: '銀行口座情報',
    bankName: '銀行',
    accountHolder: '口座名義人',
    bankCard: '銀行カード',
    amount: '出金額',
    balance: '残高',
    withdrawAll: '全額出金',
    paymentPassword: '支払いパスワード',
    passwordPlaceholder: '資金パスワードを入力してください',
    principal: '元金',
    serviceFee: 'サービス料',
    netAmount: '正味金額',
    notice: '*受取情報を慎重に確認してください',
    withdrawButton: '出金',
    walletAddress: 'ウォレットアドレス',
    walletAddressSubtitle: 'ウォレットアドレスを入力してください'
  },
  recharge: {
    title: '入金',
    amount: '入金額',
    amountSubtitle: '入金したい金額を入力してください',
    quickSelect: 'クイック選択',
    rechargeNow: '今すぐ入金',
    selectPayment: '支払い方法を選択',
    selectPaymentSubtitle: 'お好みの支払い方法を選択してください',
    cancel: 'キャンセル',
    confirm: '確認',
    crypto: '暗号通貨',
    bank: '銀行振込',
    paymentRange: '最低: {symbol}{minAmount} - 最高: {symbol}{maxAmount}',
    rechargeFailed: '入金失敗',
    paymentInfo: '支払い情報',
    usercode: 'USDTアドレス',
    uploadScreenshot: '支払いのスクリーンショットをアップロードしてください',
    clickToUpload: 'クリックしてスクリーンショットをアップロード',
    copySuccess: 'コピー成功',
    copyFailed: 'コピー失敗',
    uploadScreenshotRequired: '支払いのスクリーンショットをアップロードしてください',
    submit: '送信',
    submitting: '送信中...',
    submitSuccess: '送信成功',
    submitFailed: '送信失敗'
  },
  bindUsdt: {
    title: 'USDTをバインド',
    cardTitle: 'USDTアドレス',
    cardSubtitle: 'USDTウォレットアドレスを入力してください',
    walletAddress: 'ウォレットアドレス',
    walletAddressPlaceholder: 'USDTウォレットアドレスを入力してください',
    networkType: 'ネットワークタイプ',
    networkTypePlaceholder: 'ネットワークタイプを選択してください',
    withdrawPassword: '出金パスワード',
    withdrawPasswordPlaceholder: '出金パスワードを入力してください',
    trc20: 'TRC20',
    trc20Network: 'TRC20ネットワーク',
    erc20: 'ERC20',
    erc20Network: 'ERC20ネットワーク',
    securityNotice: 'セキュリティ通知',
    securityText1: '• USDTアドレスは暗号化され、安全に保存されています',
    securityText2: '• あなただけがこの情報を表示・変更できます',
    securityText3: '• すべての情報が正確であることを確認してください',
    buttonText: '情報を保存',
    buttonSubtitle: 'USDTアドレスをバインド',
    errorWalletAddress: 'ウォレットアドレスを入力してください',
    errorNetworkType: 'ネットワークタイプを選択してください',
    errorWithdrawPassword: '出金パスワードを入力してください'
  },
  team: {
    title: 'チーム管理',
    level1: 'レベル1チーム',
    level2: 'レベル2チーム',
    level3: 'レベル3チーム',
    level1Members: 'レベル1チームメンバー',
    level2Members: 'レベル2チームメンバー',
    level3Members: 'レベル3チームメンバー',
    totalMembers: '総メンバー数',
    totalCommission: '総コミッション',
    members: '人',
    orders: '注文',
    commission: 'コミッション',
    noMembers: 'メンバーがいません',
    loading: '読み込み中...',
    noMore: 'これ以上ありません'
  },
  bindBank: {
    title: '銀行カードをバインド',
    cardTitle: '銀行情報',
    cardSubtitle: '銀行を選択し、口座詳細を入力してください',
    bankName: '銀行',
    bankNamePlaceholder: '銀行名を入力してください',
    cardNumber: 'カード番号',
    cardNumberPlaceholder: 'カード番号を入力してください',
    realName: '本名',
    realNamePlaceholder: '本名を入力してください',
    withdrawPassword: '出金パスワード',
    withdrawPasswordPlaceholder: '出金パスワードを入力してください',
    securityNotice: 'セキュリティ通知',
    securityText1: '• 銀行情報は暗号化され、安全に保存されています',
    securityText2: '• あなただけがこの情報を表示・変更できます',
    securityText3: '• すべての情報が正確であることを確認してください',
    buttonText: '情報を保存',
    buttonSubtitle: '銀行口座をバインド',
    errorBankName: '銀行名を入力してください',
    errorCardNumber: 'カード番号を入力してください',
    errorRealName: '本名を入力してください',
    errorWithdrawPassword: '出金パスワードを入力してください'
  }
}
